<template>
  <div>
    <el-input
      class="search-el"
      size="mini"
      v-model="query.mobile_phone"
      placeholder="手机号"
    ></el-input>
    <el-input
        class="search-el"
        size="mini"
        v-model="query.search"
        placeholder="昵称"
    ></el-input>
    <el-input
      class="search-el"
      size="mini"
      v-model="query.title"
      placeholder="课程名称"
    ></el-input>
    <el-button type="primary" size="mini" @click="getList()"> 查询 </el-button>

    <el-row>
      <el-table
        v-loading="loading"
        :data="list"
        border
        size="mini"
        :stripe="true"
        style="width: 100%; margin: 20px 0"
      >        
        <el-table-column label="用户ID" align="center" min-width="20%" prop="user_id"></el-table-column>
        <el-table-column label="昵称" align="center" min-width="20%" prop="nickname"></el-table-column>
        <el-table-column label="头像" align="center" min-width="20%">
            <template slot-scope="{row}">
            <img :src="row.avatar" style="width:40px" alt="">
          </template>
        </el-table-column>
        <el-table-column label="课程" align="center" min-width="20%" prop="c_title"></el-table-column>
        <el-table-column label="小节" align="center" min-width="20%" prop="p_title"></el-table-column>
        <el-table-column label="小节时长" align="center" min-width="20%" prop="total_duration"></el-table-column>
        <el-table-column label="已学时长" align="center" min-width="20%" prop="duration"></el-table-column>
        <el-table-column label="完课率" align="center" min-width="20%" prop="complete_rate"></el-table-column>

        <el-table-column
          prop="created_at"
          label="学习时间"
          align="center"
          min-width="20%"
        ></el-table-column>

      </el-table>
    </el-row>
    <el-row>
      <div class="block">
        <el-pagination
          background
          @current-change="getList"
          :current-page.sync="query.page"
          :page-size="query.limit"
          layout="total, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </el-row>
  </div>
</template>

<script>
import {
  getUserStudyRecords,
} from "@/api/user";

export default {
  data: function () {
    return {
      list: [],
      loading: false,
      total: 0,
      query: {
        page: 1,
        limit: 10,
        search: "",
        mobile_phone: "",
        title: "",
      },
    };
  },
  created: function () {
    this.getList();
  },
  methods: {
    getList() {
      this.loading = true;
      getUserStudyRecords(this.query).then((response) => {
        this.list = response.data.list;
        this.total = response.data.total;
        this.loading = false;
      });
    },

  },
  mounted() {},
};
</script>